import clsx from 'clsx';

import ArrowRight from '@assets/icons/arrow-narrow-right.svg';

import { Card } from '../Card';
import { RoundedIcon } from '../RoundedIcon';
import { Typography } from '../Typography';

interface FeatureListItemProps {
  variant: 'primary' | 'secondary';
  size?: 'large' | 'normal' | 'small';
  data: Card;
  linkLabel?: string;
  elevated?: boolean;
}

export const FeatureListItem: React.FC<FeatureListItemProps> = ({
  variant,
  size = 'normal',
  data,
  linkLabel,
  elevated,
}) => (
  <Card
    className={clsx(
      'feature-list-item flex flex-col justify-between bg-white/80',
      size === 'large' && 'min-w-[16rem] lg:min-w-[24rem]',
      size === 'large' && elevated && 'min-h-[20.5rem] p-6',
      size === 'normal' && 'min-w-[16rem] lg:min-w-[24rem] lg:max-w-[24rem]',
      size === 'normal' && elevated && 'min-h-[20.5rem] p-6',
      size === 'small' && 'min-w-[16rem] lg:max-w-[20rem]',
      size === 'small' && elevated && 'p-6 lg:min-h-[19.5rem]',
    )}
    href={data?.link?.href}
    clickable={!!data?.link?.href}
    elevated={elevated}
  >
    <div className="flex flex-col gap-4">
      {data?.image && <RoundedIcon url={data?.image} variant={variant} />}

      <Typography variant="h5" markdown>
        {data?.title}
      </Typography>
      <Typography
        variant="body1"
        className={clsx(
          size !== 'large' && 'line-clamp-5 max-h-32',
          'text-neutral-500',
        )}
        markdown
      >
        {data?.content}
      </Typography>
    </div>

    {data?.link && (
      <div className="flex gap-2">
        <Typography variant="body1" className="text-neutral-900">
          {linkLabel}
        </Typography>

        <ArrowRight className="text-primary-500" />
      </div>
    )}
  </Card>
);
